import { Tooltip } from '@/ui/rapid-ui/tooltip'
import { organisationIndexQueryOptions } from '@jobilla/nexus-sdk'
import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { ModeBannerPill } from './mode-banner'

function useIsCurrentOrganisationDemo(): boolean {
	const { companyId } = useParams({ strict: false })
	const { data: organisations } = useQuery(organisationIndexQueryOptions())

	return organisations?.find((organisation) => organisation.slug === companyId)?.isDemo ?? false
}

export function DemoModeBanner() {
	const isDemo = useIsCurrentOrganisationDemo()

	if (!isDemo) {
		return null
	}

	return (
		<Tooltip content="Sandbox mode — no real billing or Meta ad spend on this organisation.">
			<span tabIndex={0}>
				<ModeBannerPill label="Demo Organisation" />
			</span>
		</Tooltip>
	)
}
